import React from 'react';
import { Link } from 'react-router-dom';
import { Box } from '@mui/material';
import LogoSVG from '../../assets/img/sidebar/logo.svg';

interface LogoLinkProps {
  width?: string | number;
  height?: string | number;
  padding?: string | number;
}

const LogoLink: React.FC<LogoLinkProps> = ({ width = '108.339px', height = '20px', padding = '1px' }) => (
  <Link to="/" style={{ display: 'inline-block' }}>
    <Box
      component="img"
      src={LogoSVG}
      alt="App Logo"
      sx={{
        cursor: 'pointer',
        width,
        height,
        padding,
      }}
    />
  </Link>
);

export default LogoLink;
